import { default as Bar, type AppBarProps as BarProps } from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import { useTheme } from "@mui/material/styles";
import { FC, PropsWithChildren } from "react";

export const AppBarWrapper: FC<PropsWithChildren<BarProps>> = ({ children, sx }) => {
	const theme = useTheme();

	return (
		<Bar
			sx={{
				position: { md: "static", xs: "sticky" },
				zIndex: { md: 0, xs: theme.zIndex.drawer },
				// commented out because it was used in gatsby, but not sure if it is needed in vite
				// workaround for bug in MUI: https://github.com/mui/material-ui/issues/10000, https://github.com/mui/material-ui/issues/17353
				// pr: "0 !important",
				boxShadow: theme.customShadows.far,
				backgroundColor: "white.main",
				...sx,
			}}
		>
			<Container maxWidth="md" sx={{ px: 4 }} disableGutters>
				{children}
			</Container>
		</Bar>
	);
};

 